import { useNavigate } from "@tanstack/react-router";
import { useCallback } from "react";
import { keepEnv } from "@/lib/search";

/**
 * Navigation inside a project that keeps the environment scope. `go("runs/run_4812")`
 * opens a nested path; `go("")` is Home. `go("", { env })` changes the scope.
 */
export function useProjectNav(workspace: string, project: string) {
  const navigate = useNavigate();
  return useCallback(
    (path: string, opts?: { env?: string; project?: string }) => {
      const params = { workspace, project: opts?.project ?? project };
      const search = (prev: { env?: string }) =>
        opts?.env !== undefined ? keepEnv({ env: opts.env }) : keepEnv(prev);
      if (path === "") {
        return navigate({ to: "/w/$workspace/p/$project", params, search });
      }
      return navigate({
        to: "/w/$workspace/p/$project/$",
        params: { ...params, _splat: path },
        search,
      });
    },
    [navigate, workspace, project],
  );
}
